import { useState, useEffect, useRef, useCallback } from 'react';
import { participantService, SessionState } from '../../services/participant.service';

export function useParticipantPolling(sessionId: string | null, intervalMs = 7000) {
  const [state, setState] = useState<SessionState | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const fetchState = useCallback(async () => {
    if (!sessionId) return;
    try {
      const data = await participantService.getState(sessionId);
      setState(data);
      setError(null);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    if (!sessionId) return;
    fetchState();
    intervalRef.current = setInterval(fetchState, intervalMs);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [sessionId, intervalMs, fetchState]);

  return { state, error, loading, refresh: fetchState };
}
